import React from "react";
import { useNavigate,Outlet } from 'react-router-dom'
// import { Button, Result } from 'antd';
import DHeader from '@/components/DHeader';
import DFooter from '@/components/DFooter';
import DFooter2 from '@/components/DFooter2';
import GoUp from '@/components/GoUp';




const Index = () => {
    // const navigate = useNavigate();

    return (
    <div> 
        {/* <DHeader></DHeader> */}
        <Outlet />
        <DFooter2></DFooter2>
        {/* <DFooter></DFooter>
        <GoUp></GoUp> */}
    </div>
    )
}

export default Index;